export default function FirstMonthFree() {
  return (
    <section className="mf-section mf-free-trial">
      <div className="mf-container">
        <div className="mf-free-trial-inner mf-reveal">
          <h2>Your First Month Is FREE</h2>
          <p>
            Try MilkFlow for your dairy with no subscription charge during your first month.
            Experience the full platform before you commit.
          </p>
        </div>
      </div>
    </section>
  )
}
